<template>
  <div class="m-grid m-grid--hor m-grid--root m-page">
    <AppHeader />
    <div class="m-grid__item m-grid__item--fluid m-grid m-grid--ver-desktop m-grid--desktop m-body">
      <LeftMenu />

      <div class="m-grid__item m-grid__item--fluid m-wrapper">
        <div class="m-content">
          <div class="row flex-md-column-reverse flex-sm-column-reverse flex-xxl-row flex-column-reverse">
            <div class="col-xxl- col-xl-12 col-lg-12 col-md-12" />

            <div class="col-xxl- col-xl-12">
              <!--Begin::Table-->

              <div
                class="m-portlet m-portlet--head-sm m-portlet--rounded fullable-portlet"
                :m-portlet="'true'"
              >
                <div class="m-portlet__head">
                  <div class="m-portlet__head-caption">
                    <div class="m-portlet__head-title">
                      <span class="m-portlet__head-icon">
                        <i class="flaticon-exclamation-1 m--font-brand m--icon-font-size-lg2 mt-n1" />
                      </span>
                      <h3 class="m-portlet__head-text">
                        {{ $t('TermsOfService.termsofservice') }}
                      </h3>
                    </div>
                  </div>
                  <div class="m-portlet__head-tools">
                    <ul class="m-portlet__nav">
                      <li class="m-portlet__nav-item">
                        <a
                          href="javascript:"
                          :m-portlet-tool="'fullscreen'"
                          class="m-portlet__nav-link m-portlet__nav-link--icon"
                        ><i
                          class="la la-expand"
                        /></a>
                      </li>
                    </ul>
                  </div>
                </div>

                <div
                  class="m-portlet__body"
                  v-html="$t('TermsOfService.conditions-v3')"
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <AppFooter />
  </div>
</template>

<script>

import AppHeader from '../common/Header.vue';
import AppFooter from '../common/Footer.vue';
import LeftMenu from '../common/menus/LeftMenu.vue';

export default {
    components: {
        AppFooter,
        AppHeader,
        LeftMenu,
    },
    data() {
        return {
        };
    },
};
</script>
